import Image from 'next/future/image';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const Definition = () => (
  <section className="relative flex items-end justify-center overflow-hidden bg-gray-700 p-5 md:items-center md:justify-end md:p-8">
    <div className="absolute top-0 left-0 h-1/2 w-full md:h-full">
      <Image
        src={getEdgeUrl('images/about-us/meaning/background.png')}
        alt="Vendors"
        className="h-full w-full object-cover object-top"
        height={1200}
        width={1000}
        quality={100}
      />
      <div className="absolute top-0 h-full w-full bg-gradient-to-b from-transparent to-gray-700" />
    </div>
    <div className="relative mt-[200px] w-full rounded bg-white p-5 text-gray-700 md:mt-0 md:w-[450px] md:p-8 lg:w-[575px]">
      <h2 className="text-xl font-bold leading-tight md:text-2xl">
        re.fur.bished
      </h2>
      <div className="flex gap-3 text-base">
        <span className="block">[rih-FER-bished]</span>
        <span className="block font-bold">verb</span>
      </div>
      <span className="block">Superlative: certified refurbished</span>
      <div className="my-5 h-px w-full bg-gray-700" />
      <ol className="ml-3 list-outside list-decimal space-y-5">
        <li>
          A feel-good product packaged with 0g of newly mined materials, 90%+
          energy efficiency, and 100% good vibes. A must-have in your life.
        </li>
        <li>
          Tried, tested, fool-proof, and professionally cleaned preloved goods
          that uphold industry standards. Usually bought by wise,
          forward-thinking, pocket and planet-friendly people.
        </li>
      </ol>
      <p className="mt-5">
        <b>Common synonyms:</b> Restored. Renewed. Reconditioned. Preloved.
      </p>
      <p className="mt-5">
        <b>Disclaimer:</b> You may only want to use certified refurbished
        products after reading this. The good vibes are strong!
      </p>
    </div>
  </section>
);

export default Definition;
